import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatePresence, motion } from 'framer-motion';

import { FamilyMember } from './FamilyMember';
import Spinner from 'components/Spinner';

import ProfileTabButton from './animations/ProfileTabButton';

interface UserProfileProps {
  children: React.ReactNode;
  onChange?: () => void;
}

export default function UserProfile({ children, onChange }: UserProfileProps) {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedTab, setSelectedTab] = useState<string>('my-info');

  const tabs = [
    { label: t('my_info'), value: 'my-info' },
    {
      label: t('all_profile'),
      value: 'all-profile',
    },
  ];

  return (
    <>
      <Spinner isSpinning={isLoading} />

      <div
        className='relative min-h-[calc(100vh-2rem)] h-fit p-2 rounded-xl'
        style={{
          background:
            'linear-gradient(174.13deg, rgba(255, 255, 255, 0.18) 1.16%, rgba(255, 255, 255, 0.054) 54.02%, rgba(255, 255, 255, 0.130005) 97.27%)',
        }}
      >
        <div className='flex items-center justify-center h-10 px-2 mx-auto my-2 rounded-md bg-white/40 w-fit gap-x-2'>
          {tabs.map(({ label, value }) => {
            return (
              <ProfileTabButton
                key={value as string}
                onClick={() => setSelectedTab(value)}
                isSelected={value === selectedTab}
                label={label}
              />
            );
          })}
        </div>

        <AnimatePresence mode='wait'>
          {selectedTab === 'my-info' && (
            <motion.div
              key={(selectedTab as string) || 'empty'}
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -10, opacity: 0 }}
              transition={{ duration: 0.2 }}
            >
              {children}
            </motion.div>
          )}
        </AnimatePresence>

        {selectedTab === 'all-profile' && (
          <FamilyMember
            setIsLoading={setIsLoading}
            onChange={() => {
              onChange?.();
              setSelectedTab('my-info');
            }}
          />
        )}
      </div>
    </>
  );
}
